import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '1rem', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Privacy Policy</h1>

      <p>
        This Privacy Policy explains how isLike (“we”, “our”, or “us”) collects, uses, discloses,
        and safeguards your information. By using our Service, you consent to the practices
        described below.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect personal information such as your first name, email address, and any data you
        provide when signing up or using the Service. We also collect usage data (e.g., page views
        or clicks) through analytics tools to help us improve our Service.
      </p>

      <h2>2. Use of Cookies and Analytics</h2>
      <p>
        We use cookies or similar technologies to remember user preferences, improve site performance,
        and analyze usage through tools like Google Analytics. These cookies may collect information
        such as your IP address, browser type, and usage patterns. You can adjust your browser
        settings to refuse or delete cookies, but certain features of our Service may not function
        properly without them.
      </p>

      <h2>3. Use of Google Maps API(s)</h2>
      <p>
        We use Google Maps API(s) to provide location-based data. By using our Service, you agree
        to be bound by
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noreferrer"
          style={{ marginLeft: '0.25rem' }}
        >
          Google’s Privacy Policy
        </a>.
      </p>

      <h2>4. How We Use Your Information</h2>
      <p>
        We may use the information to operate and improve our Service, personalize your experience,
        send product updates if you opt in, and respond to your inquiries or requests.
      </p>

      <h2>5. Sharing Your Information</h2>
      <p>
        We do not sell your personal information. We may share data with trusted service providers
        who assist us in operating the Service, or if required by law. These providers have access
        to personal information only as necessary to perform their functions and are obligated to
        maintain confidentiality.
      </p>

      <h2>6. Security</h2>
      <p>
        We implement reasonable measures to protect your information from unauthorized access,
        alteration, disclosure, or destruction. However, no method of transmission or storage is
        completely secure.
      </p>

      <h2>7. International Users</h2>
      <p>
        If you access the Service from outside your country of residence, your information may
        be transferred to, stored, and processed in a different country. By using the Service,
        you consent to these transfers.
      </p>

      <h2>8. Children’s Privacy</h2>
      <p>
        Our Service is not directed to individuals under 13. We do not knowingly collect personal
        information from children under 13. If you are aware of a child providing us with personal
        information, please contact us so that we can delete it.
      </p>

      <h2>9. Your Privacy Rights</h2>
      <p>
        Depending on where you live (e.g., California or the European Union), you may have the right
        to request access to, correction of, or deletion of your personal information. To exercise
        these rights, please contact us at <a href="mailto:privacy@islike.com">privacy@islike.com</a>.
      </p>

      <h2>10. Changes to this Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. We will notify you of any material
        changes by posting the new policy here. Your continued use of the Service after such
        changes constitutes acceptance of the revised policy.
      </p>

      <p style={{ marginTop: '2rem' }}>
        Last updated: March 5, 2025
      </p>
    </div>
  );
};

export default PrivacyPolicy;
